// InitialQuestions.js
import React from 'react';
import { Button } from '@material-tailwind/react';

export const InitialQuestions = ({ onQuestionClick }) => {
    const questions = [
        {
            id: 'track-order',
            text: 'Waar is mijn pakket? 📦',
            type: 'whereIsOrder'
        },
        {
            id: 'delivery-time',
            text: 'Wat is de levertijd? 🚚',
            type: 'conversation'
        },
        {
            id: 'return',
            text: 'Hoe kan ik retourneren? ↩️',
            type: 'conversation'
        },
        {
            id: 'size-guide',
            text: 'Wanneer krijg ik mijn geld terug?💸',
            type: 'conversation'
        }
    ];

    return (
        <div className="flex flex-col gap-2 w-full max-w-[250px] mx-auto">
            {questions.map((question) => (
                <Button
                    key={question.id}
                    onClick={() => onQuestionClick(question.text, question.type)}
                    className="w-full bg-gray-50 hover:bg-gray-100 text-gray-800 normal-case py-3 px-4 rounded-xl shadow-sm border border-gray-100 transition-all duration-200 text-sm text-left flex items-center gap-2 hover:shadow-md"
                >
                    {question.text}
                </Button>
            ))}
        </div>
    );
};